import { createWithEqualityFn } from 'zustand/traditional';
import { persistForUser } from '@erikdakoda/ui/shared/persistForUser';

interface State {
  todosSidebarOpen: boolean;
  selectedTodoId: string | null;
  todoFilter: string;
}

interface Action {
  setTodosSidebarOpen: (todosSidebarOpen: State['todosSidebarOpen']) => void;
  setSelectedTodoId: (selectedTodoId: State['selectedTodoId']) => void;
  clearSelectedTodo: () => void;
  setTodoFilter: (todoFilter: State['todoFilter']) => void;
}

export const useTodoStore = createWithEqualityFn<State & Action>()(
  persistForUser(
    (set) => ({
      todosSidebarOpen: false,
      selectedTodoId: null,
      todoFilter: '',

      setTodosSidebarOpen: (todosSidebarOpen) => set(() => ({ todosSidebarOpen })),
      setSelectedTodoId: (selectedTodoId) => set(() => ({ selectedTodoId })),
      clearSelectedTodo: () => set(() => ({ selectedTodoId: null })),
      setTodoFilter: (todoFilter) => set(() => ({ todoFilter })),
    }),
    {
      name: 'todo-store',
    },
  ),
);
